import axios from 'axios';
import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';
import { localStorageService } from './StorageService';

export default class ResearchService extends Singleton<ResearchService> {
  public get90DaysPrices = async ({
    manufacturerId,
    model,
    modelYear,
    trim
  }) => {
    const client = await ApiService();

    if (manufacturerId && model && modelYear) {
      try {
        const pricesResponse = await client.apis.research.getResearchGraph({
          id: 1,
          request: {
            request: {
              researchRequest: {
                manufacturerId: [manufacturerId],
                model: [model],
                modelYear,
                trim: [trim],
                inputDefinitions: []
              }
            }
          }
        });

        return pricesResponse.body?.graph;
      } catch (e) {
        return e;
      }
    }
    return null;
  };

  public getPricingAnalysis = async ({
    year,
    modelName,
    trim,
    saleDateTo,
    saleDateFrom,
    countryCode
  }) => {
    const endpoint = process.env.REACT_APP_ENTERPRISE_PRICING_ANALYSIS_ENDPOINT;
    const { accessToken } = localStorageService.getItem(
      'okta-token-storage'
    )?.accessToken;

    return new Promise((resolve, reject) => {
      axios({
        url: endpoint,
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        params: {
          yearMin: year,
          yearMax: year,
          modelNames: modelName,
          trims: trim,
          saleDateTo,
          saleDateFrom,
          countryCode,
          page: 1,
          size: 1,
          teamId: 'TRVDP'
        }
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          if (error.response) {
            reject(error.response.data.error);
          } else {
            // TODO set default error
            reject(new Error('default error'));
          }
        }
      );
    });
  };
}
